import { useEffect, useState } from 'react';
import { buildApiUrl } from '../config/apiConfig';

let cached = null;
let inflight = null;

export async function fetchStoreSettings() {
  if (cached) return cached;
  if (inflight) return inflight;

  inflight = fetch(buildApiUrl('/api/store-settings'))
    .then(async (res) => {
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'No se pudo cargar la configuración');
      cached = data.settings || {
        freeShippingThreshold: null,
        whatsappPhone: null,
      };
      return cached;
    })
    .catch(() => {
      cached = { freeShippingThreshold: null, whatsappPhone: null };
      return cached;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

export function invalidateStoreSettingsCache() {
  cached = null;
}

export function useStoreSettings() {
  const [settings, setSettings] = useState(
    cached || { freeShippingThreshold: null, whatsappPhone: null },
  );
  const [loading, setLoading] = useState(!cached);

  useEffect(() => {
    let cancelled = false;
    fetchStoreSettings().then((next) => {
      if (!cancelled) {
        setSettings(next);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { settings, loading };
}
